// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useContext } from 'react'; 
// import { AuthContext } from '../AuthContext'; 
// import { useLocation } from 'react-router-dom'; 
// import { db, set, ref, push } from '../firebase';
// import { onValue, get, runTransaction } from 'firebase/database';
// import { FaStar, FaRegStar, FaShoppingCart, FaHeart, FaShare, FaChevronLeft, FaShieldAlt, FaTruck, FaUndo, FaCertificate, FaStarHalfAlt } from 'react-icons/fa';
// import { BsArrowLeft, BsArrowRight, BsZoomIn, BsFullscreen } from 'react-icons/bs';
// import { HiOutlineSparkles } from 'react-icons/hi';
// import styled, { keyframes } from 'styled-components';
// import Navbar from './Navbar';
// import Footer from './Footer';

// // Enhanced Keyframe Animations
// const slideInFromLeft = keyframes`
//   from {
//     transform: translateX(-100px);
//     opacity: 0;
//   }
//   to {
//     transform: translateX(0);
//     opacity: 1;
//   }
// `;

// const slideInFromRight = keyframes`
//   from {
//     transform: translateX(100px);
//     opacity: 0;
//   }
//   to {
//     transform: translateX(0);
//     opacity: 1;
//   }
// `;

// const fadeInUp = keyframes`
//   from {
//     transform: translateY(30px);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(0);
//     opacity: 1;
//   }
// `;

// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-10px); }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const shimmer = keyframes`
//   0% { background-position: -200% 0; }
//   100% { background-position: 200% 0; }
// `;

// const spin = keyframes`
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// `;

// const sparkle = keyframes`
//   0%, 100% { opacity: 0; transform: scale(0.8) rotate(0deg); }
//   50% { opacity: 1; transform: scale(1) rotate(180deg); }
// `;

// // Enhanced Styled Components
// const Container = styled.div`
//   min-height: 100vh;
//   background: linear-gradient(135deg, #b0b6d8ff 0%, #e8f0ff 100%);
//   position: relative;
//   overflow: hidden;

//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background:
//       radial-gradient(circle at 20% 50%, rgba(102, 126, 234, 0.1) 0%, transparent 50%),
//       radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.1) 0%, transparent 50%),
//       radial-gradient(circle at 40% 80%, rgba(36, 198, 220, 0.1) 0%, transparent 50%);
//     animation: ${floatAnimation} 20s ease-in-out infinite;
//   }
// `;

// const MainContent = styled.div`
//   position: relative;
//   z-index: 1;
//   padding: 2rem;
  
//   @media (max-width: 768px) {
//     padding: 1rem;
//   }
// `;

// const BackButton = styled.button`
//   display: flex;
//   align-items: center;
//   gap: 0.75rem;
//   margin-bottom: 2rem;
//   color: #275f89;
//   cursor: pointer;
//   background: rgba(255, 255, 255, 0.1);
//   border: 2px solid rgba(255, 255, 255, 0.2);
//   font-size: 1rem;
//   font-weight: 600;
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   padding: 0.75rem 1.5rem;
//   border-radius: 50px;
//   backdrop-filter: blur(10px);
//   animation: ${fadeInUp} 0.6s ease-out;
  
//   &:hover {
//     background: rgba(255, 255, 255, 0.2);
//     transform: translateX(-8px) translateY(-2px);
//     box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
//   }
  
//   svg {
//     transition: transform 0.3s ease;
//   }
  
//   &:hover svg {
//     transform: translateX(-5px);
//   }
// `;

// const ProductContainer = styled.div`
//   max-width: 1400px;
//   margin: 0 auto;
//   background: rgba(255, 255, 255, 0.95);
//   border-radius: 24px;
//   box-shadow: 
//     0 25px 50px rgba(0, 0, 0, 0.15),
//     0 0 0 1px rgba(255, 255, 255, 0.1);
//   overflow: hidden;
//   backdrop-filter: blur(20px);
//   animation: ${fadeInUp} 0.8s ease-out 0.2s both;
//   position: relative;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
//     animation: ${shimmer} 3s ease-in-out infinite;
//   }
// `;

// const ProductContent = styled.div`
//   display: flex;
//   flex-direction: column;
//   position: relative;
//   z-index: 2;
  
//   @media (min-width: 1024px) {
//     flex-direction: row;
//   }
// `;

// const ImageSection = styled.div`
//   flex: 1.2;
//   position: relative;
//   padding: 3rem;
//   background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
//   animation: ${slideInFromLeft} 0.8s ease-out 0.4s both;
  
//   @media (max-width: 1024px) {
//     padding: 2rem;
//   }
  
//   @media (max-width: 768px) {
//     padding: 1.5rem;
//   }
// `;

// const ImageContainer = styled.div`
//   position: relative;
//   background: white;
//   border-radius: 20px;
//   padding: 2rem;
//   box-shadow: 
//     0 20px 40px rgba(0, 0, 0, 0.1),
//     inset 0 1px 0 rgba(255, 255, 255, 0.6);
//   overflow: hidden;
  
//   &:hover {
//     box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
//   }
// `;

// const MainImage = styled.img`
//   width: 100%;
//   height: 500px;
//   object-fit: contain;
//   border-radius: 16px;
//   transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
//   cursor: zoom-in;
  
//   &:hover {
//     transform: scale(1.05) rotate(1deg);
//   }
  
//   @media (max-width: 768px) {
//     height: 350px;
//   }
// `;

// const ImageOverlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background: linear-gradient(
//     45deg,
//     rgba(102, 126, 234, 0.1) 0%,
//     transparent 30%,
//     transparent 70%,
//     rgba(118, 75, 162, 0.1) 100%
//   );
//   opacity: 0;
//   transition: opacity 0.3s ease;
//   border-radius: 16px;
  
//   ${ImageContainer}:hover & {
//     opacity: 1;
//   }
// `;

// const ThumbnailContainer = styled.div`
//   display: flex;
//   gap: 1rem;
//   margin-top: 2rem;
//   overflow-x: auto;
//   padding-bottom: 1rem;
//   scrollbar-width: thin;
//   scrollbar-color: #667eea #f1f3f4;
  
//   &::-webkit-scrollbar {
//     height: 8px;
//   }
  
//   &::-webkit-scrollbar-track {
//     background: #f1f3f4;
//     border-radius: 4px;
//   }
  
//   &::-webkit-scrollbar-thumb {
//     background: linear-gradient(45deg, #667eea, #764ba2);
//     border-radius: 4px;
//   }
// `;

// const Thumbnail = styled.img.withConfig({
//   shouldForwardProp: (prop) => prop !== 'active'
// })`
//   width: 80px;
//   height: 80px;
//   object-fit: cover;
//   border-radius: 12px;
//   cursor: pointer;
//   border: 3px solid ${props => props.active ? '#667eea' : 'transparent'};
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//   position: relative;
  
//   &:hover {
//     border-color: #667eea;
//     transform: translateY(-4px) scale(1.05);
//     box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
//   }
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: -2px;
//     left: -2px;
//     right: -2px;
//     bottom: -2px;
//     background: linear-gradient(45deg, #667eea, #764ba2);
//     border-radius: 12px;
//     z-index: -1;
//     opacity: ${props => props.active ? 1 : 0};
//     transition: opacity 0.3s ease;
//   }
// `;

// const NavButton = styled.button`
//   position: absolute;
//   top: 50%;
//   transform: translateY(-50%);
//   background: rgba(255, 255, 255, 0.95);
//   border-radius: 50%;
//   width: 56px;
//   height: 56px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border: none;
//   cursor: pointer;
//   box-shadow: 
//     0 8px 25px rgba(0, 0, 0, 0.15),
//     0 4px 10px rgba(0, 0, 0, 0.1);
//   color: #667eea;
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   z-index: 10;
//   backdrop-filter: blur(10px);
  
//   &:hover {
//     background: #667eea;
//     color: white;
//     transform: translateY(-50%) scale(1.1);
//     box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
//   }
  
//   &:disabled {
//     opacity: 0.4;
//     cursor: not-allowed;
    
//     &:hover {
//       background: rgba(255, 255, 255, 0.95);
//       color: #667eea;
//       transform: translateY(-50%);
//     }
//   }
// `;

// const PrevButton = styled(NavButton)`
//   left: 2rem;
// `;

// const NextButton = styled(NavButton)`
//   right: 2rem;
// `;

// const DetailsSection = styled.div`
//   flex: 1;
//   padding: 3rem;
//   background: white;
//   animation: ${slideInFromRight} 0.8s ease-out 0.6s both;
//   position: relative;
  
//   @media (max-width: 1024px) {
//     padding: 2rem;
//   }
  
//   @media (max-width: 768px) {
//     padding: 1.5rem;
//   }
// `;

// const ProductTitle = styled.h1`
//   font-size: 2.5rem;
//   font-weight: 800;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   margin-bottom: 0.5rem;
//   line-height: 1.2;
//   animation: ${fadeInUp} 0.6s ease-out 0.8s both;
//   position: relative;
  
//   &:after {
//     content: '';
//     position: absolute;
//     top: -5px;
//     right: -20px;
//     width: 20px;
//     height: 20px;
//     background: linear-gradient(45deg, #FFD700, #FFA500);
//     border-radius: 50%;
//     animation: ${sparkle} 2s ease-in-out infinite;
//   }
  
//   @media (max-width: 768px) {
//     font-size: 2rem;
//   }
// `;

// const ProductBrand = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.5rem;
//   font-size: 1.1rem;
//   color: white;
//   margin-bottom: 1.5rem;
//   font-weight: 600;
//   padding: 0.5rem 1.5rem;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   border-radius: 50px;
//   box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
//   animation: ${fadeInUp} 0.6s ease-out 1s both;
  
//   &:before {
//     content: '✨';
//     animation: ${sparkle} 1.5s ease-in-out infinite;
//   }
// `;

// const ProductRating = styled.div`
//   display: flex;
//   align-items: center;
//   margin-bottom: 1.5rem;
//   background: linear-gradient(135deg, #fff5f5 0%, #ffeaa7 100%);
//   padding: 0.75rem 1.5rem;
//   border-radius: 50px;
//   width: fit-content;
//   box-shadow: 0 4px 15px rgba(255, 193, 7, 0.2);
//   animation: ${fadeInUp} 0.6s ease-out 1.2s both;
//   border: 2px solid rgba(255, 193, 7, 0.1);
// `;

// const RatingCount = styled.span`
//   font-size: 0.95rem;
//   color: #666;
//   margin-left: 0.75rem;
//   font-weight: 500;
// `;

// const PriceContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 1.5rem;
//   margin-bottom: 2rem;
//   flex-wrap: wrap;
//   animation: ${fadeInUp} 0.6s ease-out 1.4s both;
// `;

// const CurrentPrice = styled.span`
//   font-size: 2.5rem;
//   font-weight: 900;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   position: relative;
  
//   &:after {
//     content: '';
//     position: absolute;
//     bottom: -5px;
//     left: 0;
//     right: 0;
//     height: 3px;
//     background: linear-gradient(90deg, #667eea, #764ba2);
//     border-radius: 2px;
//     animation: ${pulse} 2s ease-in-out infinite;
//   }
// `;

// const OriginalPrice = styled.span`
//   font-size: 1.5rem;
//   color: #999;
//   text-decoration: line-through;
//   font-weight: 500;
//   opacity: 0.8;
// `;

// const DiscountBadge = styled.span`
//   font-size: 1rem;
//   font-weight: 700;
//   background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
//   color: white;
//   padding: 0.5rem 1rem;
//   border-radius: 50px;
//   box-shadow: 0 8px 20px rgba(255, 107, 107, 0.4);
//   animation: ${pulse} 1.5s ease-in-out infinite;
  
//   &:before {
//     content: '🔥 ';
//   }
// `;

// const TotalPrice = styled.div`
//   font-size: 1.3rem;
//   font-weight: 700;
//   color: #1a1a1a;
//   margin-bottom: 2rem;
//   padding: 1.5rem;
//   background: linear-gradient(135deg, #667eea 10%, #764ba2 100%);
//   background-size: 200% 200%;
//   animation: ${shimmer} 3s ease-in-out infinite;
//   color: white;
//   border-radius: 16px;
//   display: inline-block;
//   box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
//   position: relative;
//   overflow: hidden;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
//     animation: ${shimmer} 2s ease-in-out infinite;
//   }
// `;

// const ProductDescription = styled.p`
//   font-size: 1.1rem;
//   color: #555;
//   margin-bottom: 2rem;
//   line-height: 1.8;
//   animation: ${fadeInUp} 0.6s ease-out 1.6s both;
//   padding: 1.5rem;
//   background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
//   border-radius: 16px;
//   border-left: 4px solid #667eea;
// `;

// const SectionTitle = styled.h3`
//   font-size: 1.3rem;
//   font-weight: 700;
//   color: #1a1a1a;
//   margin-bottom: 1.5rem;
//   position: relative;
//   padding-bottom: 0.75rem;
  
//   &:after {
//     content: '';
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     width: 60px;
//     height: 4px;
//     background: linear-gradient(90deg, #667eea, #764ba2);
//     border-radius: 4px;
//   }
// `;

// const FeatureGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 1rem;
//   margin-bottom: 2rem;
//   animation: ${fadeInUp} 0.6s ease-out 1.8s both;
// `;

// const FeatureCard = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 0.75rem;
//   padding: 1rem;
//   background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
//   border-radius: 12px;
//   border: 1px solid rgba(102, 126, 234, 0.1);
//   transition: all 0.3s ease;
  
//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 8px 20px rgba(102, 126, 234, 0.15);
//     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//     color: white;
//   }
  
//   svg {
//     font-size: 1.5rem;
//     color: #667eea;
//     transition: all 0.3s ease;
//   }
  
//   &:hover svg {
//     color: white;
//     transform: scale(1.1);
//   }
// `;

// const FeatureText = styled.div`
//   font-size: 0.9rem;
//   font-weight: 600;
// `;

// const ColorOptions = styled.div`
//   display: flex;
//   gap: 1rem;
//   margin-bottom: 2rem;
//   flex-wrap: wrap;
//   animation: ${fadeInUp} 0.6s ease-out 2s both;
// `;

// const ColorOption = styled.div`
//   width: 50px;
//   height: 50px;
//   border-radius: 50%;
//   cursor: pointer;
//   border: 4px solid ${props => props.selected ? '#667eea' : 'transparent'};
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   position: relative;
//   background-color: ${props => props.color || '#ccc'};
//   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: -8px;
//     left: -8px;
//     right: -8px;
//     bottom: -8px;
//     border: 2px solid rgba(102, 126, 234, 0.3);
//     border-radius: 50%;
//     opacity: ${props => props.selected ? 1 : 0};
//     transition: opacity 0.3s ease;
//     animation: ${props => props.selected ? pulse : 'none'} 2s ease-in-out infinite;
//   }
  
//   &:hover {
//     transform: scale(1.2);
//     box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
//   }
// `;

// const SizeOptions = styled.div`
//   display: flex;
//   gap: 1rem;
//   margin-bottom: 2rem;
//   flex-wrap: wrap;
//   animation: ${fadeInUp} 0.6s ease-out 2.2s both;
// `;

// const SizeOption = styled.div`
//   padding: 0.75rem 1.5rem;
//   border: 2px solid ${props => props.selected ? '#667eea' : '#e0e3e7'};
//   border-radius: 50px;
//   cursor: pointer;
//   font-size: 1rem;
//   font-weight: 600;
//   background: ${props => props.selected ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white'};
//   color: ${props => props.selected ? 'white' : '#555'};
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  
//   &:hover {
//     border-color: #667eea;
//     transform: translateY(-3px);
//     box-shadow: 0 8px 20px rgba(102, 126, 234, 0.2);
//   }
// `;

// const QuantitySelector = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 1.5rem;
//   margin-bottom: 2rem;
//   animation: ${fadeInUp} 0.6s ease-out 2.4s both;
// `;

// const QuantityButton = styled.button`
//   width: 44px;
//   height: 44px;
//   border-radius: 50%;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   border: none;
//   cursor: pointer;
//   font-size: 1.3rem;
//   font-weight: 700;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   color: white;
//   box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  
//   &:hover {
//     transform: scale(1.1);
//     box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
//   }
  
//   &:disabled {
//     opacity: 0.5;
//     cursor: not-allowed;
//     transform: none;
//   }
// `;

// const QuantityInput = styled.input`
//   width: 80px;
//   text-align: center;
//   padding: 0.75rem;
//   border: 2px solid #e0e3e7;
//   border-radius: 12px;
//   font-size: 1.2rem;
//   font-weight: 600;
//   background: white;
//   transition: all 0.3s ease;
  
//   &:focus {
//     outline: none;
//     border-color: #667eea;
//     box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
//     background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
//   }
// `;

// const ActionButtons = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 1rem;
//   margin-bottom: 2rem;
//   animation: ${fadeInUp} 0.6s ease-out 2.6s both;
// `;

// const BuyNowButton = styled.button`
//   padding: 1.25rem;
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//   color: white;
//   border: none;
//   border-radius: 16px;
//   cursor: pointer;
//   font-size: 1.2rem;
//   font-weight: 700;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 0.75rem;
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
//   position: relative;
//   overflow: hidden;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
//     transition: left 0.5s ease;
//   }
  
//   &:hover {
//     transform: translateY(-3px);
//     box-shadow: 0 12px 35px rgba(102, 126, 234, 0.5);
    
//     &:before {
//       left: 100%;
//     }
//   }
  
//   &:active {
//     transform: translateY(-1px);
//   }
// `;

// const AddToCartButton = styled.button`
//   padding: 1.25rem;
//   background: linear-gradient(135deg, #24c6dc 0%, #514a9d 100%);
//   color: white;
//   border: none;
//   border-radius: 16px;
//   cursor: pointer;
//   font-size: 1.2rem;
//   font-weight: 700;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 0.75rem;
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   box-shadow: 0 8px 25px rgba(36, 198, 220, 0.4);
//   position: relative;
//   overflow: hidden;
  
//   &:before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: -100%;
//     width: 100%;
//     height: 100%;
//     background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
//     transition: left 0.5s ease;
//   }
  
//   &:hover {
//     transform: translateY(-3px);
//     box-shadow: 0 12px 35px rgba(36, 198, 220, 0.5);
    
//     &:before {
//       left: 100%;
//     }
//   }
  
//   &:active {
//     transform: translateY(-1px);
//   }
// `;

// const SecondaryButtons = styled.div`
//   display: flex;
//   gap: 1rem;
// `;

// const WishlistButton = styled.button.withConfig({
//   shouldForwardProp: (prop) => prop !== 'isWishlisted'
// })`
//   flex: 1;
//   padding: 1rem;
//   background: ${props => props.isWishlisted
//     ? 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)'
//     : 'linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%)'};
//   color: ${props => props.isWishlisted ? 'white' : '#667eea'};
//   border: 2px solid ${props => props.isWishlisted ? 'transparent' : '#667eea'};
//   border-radius: 16px;
//   cursor: pointer;
//   font-size: 1rem;
//   font-weight: 600;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 0.5rem;
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
//   }
// `;

// const ShareButton = styled.button`
//   flex: 1;
//   padding: 1rem;
//   background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
//   color: #667eea;
//   border: 2px solid #667eea;
//   border-radius: 16px;
//   cursor: pointer;
//   font-size: 1rem;
//   font-weight: 600;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 0.5rem;
//   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
//   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  
//   &:hover {
//     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//     color: white;
//     transform: translateY(-2px);
//     box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
//   }
// `;

// const SpecsContainer = styled.div`
//   margin-top: 3rem;
//   background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%);
//   padding: 2rem;
//   border-radius: 20px;
//   box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
//   animation: ${fadeInUp} 0.6s ease-out 2.8s both;
// `;

// const SpecsTable = styled.table`
//   width: 100%;
//   border-collapse: separate;
//   border-spacing: 0 1rem;
// `;

// const SpecsRow = styled.tr`
//   transition: all 0.3s ease;
  
//   &:hover {
//     transform: translateX(5px);
//   }
// `;

// const SpecsHeader = styled.th`
//   padding: 1.25rem;
//   text-align: left;
//   font-weight: 700;
//   color: #667eea;
//   width: 30%;
//   background: white;
//   border-radius: 12px 0 0 12px;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
// `;

// const SpecsCell = styled.td`
//   padding: 1.25rem;
//   color: #555;
//   font-weight: 500;
//   background: white;
//   border-radius: 0 12px 12px 0;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
// `;

// const LoadingContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   min-height: 60vh;
//   gap: 2rem;
// `;

// const LoadingSpinner = styled.div`
//   width: 80px;
//   height: 80px;
//   border: 6px solid rgba(102, 126, 234, 0.1);
//   border-top: 6px solid #667eea;
//   border-radius: 50%;
//   animation: ${spin} 1s linear infinite;
// `;

// const LoadingText = styled.div`
//   font-size: 1.2rem;
//   font-weight: 600;
//   color: white;
//   text-align: center;
// `;

// const ErrorMessage = styled.div`
//   text-align: center;
//   padding: 3rem;
//   color: #ff6b6b;
//   background: rgba(255, 255, 255, 0.95);
//   border-radius: 20px;
//   max-width: 600px;
//   margin: 0 auto;
//   font-weight: 600;
//   box-shadow: 0 10px 30px rgba(255, 107, 107, 0.2);
//   backdrop-filter: blur(10px);
// `;

// const ProductDetail = () => {
//   const { productId } = useParams();
//   const navigate = useNavigate();
//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [quantity, setQuantity] = useState(1);
//   const [selectedSize, setSelectedSize] = useState(null);
//   const [isWishlisted, setIsWishlisted] = useState(false);
//   const location = useLocation();

//   // Get user from AuthContext or localStorage
//   const { currentUser } = useContext(AuthContext) || {};
//   const localStorageUser = JSON.parse(localStorage.getItem('userData'));
//   const user = currentUser || localStorageUser;

//   const getColorValue = (colorName) => {
//     const colorMap = {
//       'black': '#1a1a1a',
//       'white': '#ffffff',
//       'red': '#e74c3c',
//       'blue': '#3498db',
//       'green': '#27ae60',
//       'yellow': '#f1c40f',
//       'silver': '#bdc3c7',
//       'gold': '#f39c12',
//       'rose gold': '#e8b4b8',
//       'navy': '#2c3e50',
//       'brown': '#8b4513',
//       'gray': '#7f8c8d',
//       'grey': '#7f8c8d',
//       'pink': '#e91e63',
//       'purple': '#9b59b6',
//       'orange': '#e67e22',
//       'beige': '#f5f5dc',
//       'teal': '#1abc9c',
//       'burgundy': '#8e2a2a'
//     };

//     return colorMap[colorName.toLowerCase()] || colorName;
//   };

//   const [selectedColor, setSelectedColor] = useState(
//     product?.specifications?.colors?.[0] || null
//   );

//   useEffect(() => {
//     if (product?.specifications?.colors?.length > 0) {
//       setSelectedColor(product.specifications.colors[0]);
//     }
//   }, [product]);

//   const calculateCurrentPrice = () => {
//     if (!product) return 0;
//     const basePrice = parseFloat(product.price);
//     const discountedPrice = product.discount > 0
//       ? basePrice * (1 - product.discount / 100)
//       : basePrice;
//     return (discountedPrice * quantity).toFixed(2);
//   };

//   const calculateOriginalPrice = () => {
//     if (!product) return 0;
//     return (parseFloat(product.price) * quantity).toFixed(2);
//   };

//   useEffect(() => {
//     const productRef = ref(db, `Watch/admin/products/${productId}`);
//     const unsubscribe = onValue(productRef, (snapshot) => {
//       const productData = snapshot.val();
//       if (productData) {
//         setProduct({
//           id: productId,
//           ...productData
//         });
//         if (productData.specifications?.color) {
//           setSelectedColor(productData.specifications.color);
//         }
//         if (productData.specifications?.sizes?.[0]) {
//           setSelectedSize(productData.specifications.sizes[0]);
//         }
//       } else {
//         setError('Product not found');
//       }
//       setLoading(false);
//     }, (error) => {
//       setError('Error fetching product details');
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, [productId]);

//   const handleQuantityChange = (change) => {
//     const newQuantity = quantity + change;
//     if (newQuantity >= 1 && newQuantity <= 10) {
//       setQuantity(newQuantity);
//     }
//   };

//   const handleQuantityInput = (e) => {
//     const value = parseInt(e.target.value);
//     if (!isNaN(value) && value >= 1 && value <= 10) {
//       setQuantity(value);
//     }
//   };

//   const nextImage = () => {
//     if (product.images && currentImageIndex < product.images.length - 1) {
//       setCurrentImageIndex(currentImageIndex + 1);
//     }
//   };

//   const prevImage = () => {
//     if (currentImageIndex > 0) {
//       setCurrentImageIndex(currentImageIndex - 1);
//     }
//   };

//   const handleAddToCart = async () => {
//     if (!user || !user.id) {
//       alert('Please login to add items to cart');
//       navigate('/login', { state: { from: location.pathname } });
//       return;
//     }

//     try {
//       const cartRef = ref(db, `Watch/customers/${user.id}/cart`);
//       const snapshot = await get(cartRef);
//       const cartItems = snapshot.val() || {};

//       const existingItemKey = Object.keys(cartItems).find(key =>
//         cartItems[key].id === product.id &&
//         cartItems[key].selectedColor === selectedColor &&
//         cartItems[key].selectedSize === selectedSize
//       );

//       if (existingItemKey) {
//         const itemRef = ref(db, `Watch/customers/${user.id}/cart/${existingItemKey}`);
//         await runTransaction(itemRef, (currentData) => {
//           if (currentData) {
//             currentData.quantity += quantity;
//           }
//           return currentData;
//         });
//       } else {
//         const newCartItem = {
//           id: product.id,
//           name: product.name,
//           brand: product.brand,
//           price: parseFloat(product.price),
//           discount: product.discount || 0,
//           image: product.images?.[0] || '',
//           selectedColor,
//           selectedSize,
//           quantity,
//           maxQuantity: 10,
//           addedAt: Date.now()
//         };

//         await push(ref(db, `Watch/customers/${user.id}/cart`), newCartItem);
//       }

//       alert(`${quantity} ${product.name} (${selectedColor}) added to cart`);
//       navigate('/cart');

//     } catch (err) {
//       console.error('Error adding to cart:', err);
//       alert('Failed to add item to cart. Please try again.');
//     }
//   };

//   const handleBuyNow = () => {
//     if (!user || !user.id) {
//       alert('Please login to proceed with checkout');
//       navigate('/login', { state: { from: location.pathname } });
//       return;
//     }

//     const cartItem = {
//       id: product.id,
//       name: product.name,
//       brand: product.brand,
//       price: parseFloat(product.price),
//       discount: product.discount || 0,
//       image: product.images?.[0] || '',
//       selectedColor,
//       selectedSize,
//       quantity,
//       maxQuantity: 10,
//       userId: user.id
//     };

//     localStorage.setItem('cart', JSON.stringify([cartItem]));
//     navigate('/checkout', {
//       state: {
//         fromBuyNow: true,
//         product: {
//           ...cartItem,
//           originalPrice: parseFloat(product.price)
//         }
//       }
//     });
//   };

//   const toggleWishlist = () => {
//     setIsWishlisted(!isWishlisted);
//     if (!isWishlisted) {
//       alert(`${product.name} added to wishlist`);
//     }
//   };

//   const renderRating = (rating) => {
//     const stars = [];
//     const ratingValue = rating || 4.5;
//     const fullStars = Math.floor(ratingValue);
//     const hasHalfStar = ratingValue % 1 >= 0.5;

//     for (let i = 0; i < fullStars; i++) {
//       stars.push(<FaStar key={`full-${i}`} style={{ color: '#ffb400', fontSize: '1.2rem' }} />);
//     }

//     if (hasHalfStar) {
//       stars.push(<FaStarHalfAlt key="half" style={{ color: '#ffb400', fontSize: '1.2rem' }} />);
//     }

//     const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
//     for (let i = 0; i < emptyStars; i++) {
//       stars.push(<FaRegStar key={`empty-${i}`} style={{ color: '#ffb400', fontSize: '1.2rem' }} />);
//     }

//     return stars;
//   };

//   if (loading) {
//     return (
//       <Container>
//         <MainContent>
//           <LoadingContainer>
//             <LoadingSpinner />
//             <LoadingText>Loading amazing product details...</LoadingText>
//           </LoadingContainer>
//         </MainContent>
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container>
//         <MainContent>
//           <ErrorMessage>
//             <h3>Oops! {error}</h3>
//             <p>We couldn't find what you're looking for.</p>
//             <BackButton onClick={() => navigate(-1)}>
//               <FaChevronLeft /> Back to Products
//             </BackButton>
//           </ErrorMessage>
//         </MainContent>
//       </Container>
//     );
//   }

//   if (!product) {
//     return (
//       <Container>
//         <MainContent>
//           <ErrorMessage>
//             <h3>Product not found</h3>
//             <p>This product might have been moved or deleted.</p>
//             <BackButton onClick={() => navigate(-1)}>
//               <FaChevronLeft /> Back to Products
//             </BackButton>
//           </ErrorMessage>
//         </MainContent>
//       </Container>
//     );
//   }

//   return (
//     <>
//       <Navbar />
//       <Container>
//         <MainContent>
//           <BackButton onClick={() => navigate(-1)}>
//             <FaChevronLeft /> Back to Products
//           </BackButton>

//           <ProductContainer>
//             <ProductContent>
//               <ImageSection>
//                 {product.images && product.images.length > 0 && (
//                   <>
//                     <ImageContainer>
//                       <MainImage
//                         src={product.images[currentImageIndex]}
//                         alt={product.name}
//                       />
//                       <ImageOverlay />
//                       {product.images.length > 1 && (
//                         <>
//                           <PrevButton
//                             onClick={prevImage}
//                             disabled={currentImageIndex === 0}
//                           >
//                             <BsArrowLeft />
//                           </PrevButton>
//                           <NextButton
//                             onClick={nextImage}
//                             disabled={currentImageIndex === product.images.length - 1}
//                           >
//                             <BsArrowRight />
//                           </NextButton>
//                         </>
//                       )}
//                     </ImageContainer>
                    
//                     <ThumbnailContainer>
//                       {product.images.map((image, index) => (
//                         <Thumbnail
//                           key={index}
//                           src={image}
//                           alt={`${product.name} thumbnail ${index + 1}`}
//                           active={index === currentImageIndex}
//                           onClick={() => setCurrentImageIndex(index)}
//                         />
//                       ))}
//                     </ThumbnailContainer>
//                   </>
//                 )}

//                 <SpecsContainer>
//                   <SectionTitle>✨ Product Specifications</SectionTitle>
//                   <SpecsTable>
//                     <tbody>
//                       {product.specifications && Object.entries(product.specifications).map(([key, value]) => {
//                         if (key === 'color' || key === 'sizes') return null;
//                         return (
//                           <SpecsRow key={key}>
//                             <SpecsHeader>{key.charAt(0).toUpperCase() + key.slice(1)}</SpecsHeader>
//                             <SpecsCell>
//                               {Array.isArray(value) ? value.join(', ') : value}
//                             </SpecsCell>
//                           </SpecsRow>
//                         );
//                       })}
//                     </tbody>
//                   </SpecsTable>
//                 </SpecsContainer>
//               </ImageSection>

//               <DetailsSection>
//                 <ProductTitle>{product.name}</ProductTitle>
//                 <ProductBrand>{product.brand}</ProductBrand>

//                 <ProductRating>
//                   {renderRating(4.5)}
//                   <RatingCount>(128 reviews)</RatingCount>
//                 </ProductRating>

//                 <FeatureGrid>
//                   <FeatureCard>
//                     <FaShieldAlt />
//                     <FeatureText>1 Year Warranty</FeatureText>
//                   </FeatureCard>
//                   <FeatureCard>
//                     <FaTruck />
//                     <FeatureText>Free Delivery</FeatureText>
//                   </FeatureCard>
//                   <FeatureCard>
//                     <FaUndo />
//                     <FeatureText>Easy Returns</FeatureText>
//                   </FeatureCard>
//                   <FeatureCard>
//                     <FaCertificate />
//                     <FeatureText>Authentic Product</FeatureText>
//                   </FeatureCard>
//                 </FeatureGrid>

//                 <PriceContainer>
//                   {product.discount > 0 ? (
//                     <>
//                       <CurrentPrice>₹{calculateCurrentPrice()}</CurrentPrice>
//                       <OriginalPrice>₹{calculateOriginalPrice()}</OriginalPrice>
//                       <DiscountBadge>{product.discount}% OFF</DiscountBadge>
//                     </>
//                   ) : (
//                     <CurrentPrice>���{calculateCurrentPrice()}</CurrentPrice>
//                   )}
//                 </PriceContainer>

//                 <TotalPrice>
//                   💫 Total: ₹{calculateCurrentPrice()} ({quantity} {quantity > 1 ? 'items' : 'item'})
//                 </TotalPrice>

//                 <ProductDescription>
//                   {product.description || "Experience the perfect blend of style and functionality with this premium product. Crafted with attention to detail and designed for modern lifestyle."}
//                 </ProductDescription>

//                 {product.specifications?.colors && product.specifications.colors.length > 0 && (
//                   <>
//                     <SectionTitle>🎨 Choose Color</SectionTitle>
//                     <ColorOptions>
//                       {product.specifications.colors.map((color) => (
//                         <ColorOption
//                           key={color}
//                           color={getColorValue(color)}
//                           selected={selectedColor === color}
//                           onClick={() => setSelectedColor(color)}
//                           title={color}
//                         />
//                       ))}
//                     </ColorOptions>
//                   </>
//                 )}

//                 {product.specifications?.sizes && (
//                   <>
//                     <SectionTitle>📏 Select Size</SectionTitle>
//                     <SizeOptions>
//                       {product.specifications.sizes.map((size) => (
//                         <SizeOption
//                           key={size}
//                           selected={selectedSize === size}
//                           onClick={() => setSelectedSize(size)}
//                         >
//                           {size}
//                         </SizeOption>
//                       ))}
//                     </SizeOptions>
//                   </>
//                 )}

//                 <QuantitySelector>
//                   <SectionTitle>🔢 Quantity</SectionTitle>
//                   <QuantityButton
//                     onClick={() => handleQuantityChange(-1)}
//                     disabled={quantity <= 1}
//                   >
//                     -
//                   </QuantityButton>
//                   <QuantityInput
//                     type="number"
//                     value={quantity}
//                     min="1"
//                     max="10"
//                     onChange={handleQuantityInput}
//                   />
//                   <QuantityButton
//                     onClick={() => handleQuantityChange(1)}
//                     disabled={quantity >= 10}
//                   >
//                     +
//                   </QuantityButton>
//                 </QuantitySelector>

//                 <ActionButtons>
//                   <BuyNowButton onClick={handleBuyNow}>
//                     <HiOutlineSparkles /> Buy Now
//                   </BuyNowButton>
//                   <AddToCartButton onClick={handleAddToCart}>
//                     <FaShoppingCart /> Add to Cart
//                   </AddToCartButton>
//                   <SecondaryButtons>
                  
                    
//                   </SecondaryButtons>
//                 </ActionButtons>
//               </DetailsSection>
//             </ProductContent>
//           </ProductContainer>
//         </MainContent>
//       </Container>
//       <Footer />
//     </>
//   );
// };

// export default ProductDetail;


import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useContext } from 'react'; 
import { AuthContext } from '../AuthContext'; 
import { useLocation } from 'react-router-dom'; 
import { db, set, ref, push } from '../firebase';
import { onValue, get, runTransaction } from 'firebase/database';
import { FaStar, FaRegStar, FaShoppingCart, FaHeart, FaShare, FaChevronLeft, FaShieldAlt, FaTruck, FaUndo, FaCertificate, FaStarHalfAlt } from 'react-icons/fa';
import { BsArrowLeft, BsArrowRight, BsZoomIn, BsFullscreen } from 'react-icons/bs';
import { HiOutlineSparkles } from 'react-icons/hi';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';

// Compact Styled Components
const Container = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
`;

const MainContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem;
  
  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: #666;
  
  a {
    color: #667eea;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  span {
    color: #999;
  }
`;

const ProductContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
`;

const ProductContent = styled.div`
  display: grid;
  grid-template-columns: 45% 55%;
  gap: 2rem;
  padding: 1.5rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  @media (max-width: 768px) {
    padding: 1rem;
    gap: 1rem;
  }
`;

const ImageSection = styled.div`
  position: relative;
`;

const ImageContainer = styled.div`
  position: relative;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const MainImage = styled.img`
  width: 100%;
  height: 450px;
  object-fit: contain;
  border-radius: 8px;
  transition: transform 0.3s ease;
  
  @media (max-width: 768px) {
    height: 300px;
  }
`;

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  color: #667eea;
  transition: all 0.3s ease;
  z-index: 2;
  
  &:hover {
    background: #f5f5f5;
  }
  
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

const PrevButton = styled(NavButton)`
  left: 1rem;
`;

const NextButton = styled(NavButton)`
  right: 1rem;
`;

const ThumbnailContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
  
  &::-webkit-scrollbar {
    height: 6px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #667eea;
    border-radius: 3px;
  }
`;

const Thumbnail = styled.img`
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid ${props => props.active ? '#667eea' : '#e0e0e0'};
  transition: all 0.3s ease;
  flex-shrink: 0;
  
  &:hover {
    border-color: #667eea;
  }
`;

const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductHeader = styled.div`
  margin-bottom: 1rem;
`;

const ProductTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
  line-height: 1.3;
  
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const ProductBrand = styled.div`
  font-size: 0.9375rem;
  color: #667eea;
  font-weight: 600;
  margin-bottom: 0.75rem;
`;

const ProductRating = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  
  .stars {
    display: flex;
    gap: 0.25rem;
  }
`;

const RatingBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: #ffc107;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
`;

const ReviewCount = styled.span`
  font-size: 0.875rem;
  color: #666;
`;

const PriceSection = styled.div`
  padding: 1rem 0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 1rem;
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
`;

const CurrentPrice = styled.span`
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const OriginalPrice = styled.span`
  font-size: 1.125rem;
  color: #999;
  text-decoration: line-through;
`;

const DiscountBadge = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  background: #ff4444;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
`;

const TaxInfo = styled.div`
  font-size: 0.8125rem;
  color: #666;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 0.875rem;
  color: #1a1a1a;
  transition: all 0.3s ease;
  
  &:hover {
    background: #f0f0f0;
  }
  
  svg {
    font-size: 1.25rem;
    color: #667eea;
    flex-shrink: 0;
  }
`;

const FeatureText = styled.div`
  font-weight: 500;
  line-height: 1.3;
`;

const ProductDescription = styled.p`
  font-size: 0.9375rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
`;

const SectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const ColorSection = styled.div`
  margin-bottom: 1.5rem;
`;

const ColorOptions = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

const ColorOption = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid ${props => props.selected ? '#667eea' : '#e0e0e0'};
  background-color: ${props => props.color};
  transition: all 0.3s ease;
  position: relative;
  
  &:hover {
    border-color: #667eea;
  }
  
  ${props => props.selected && `
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  `}
`;

const SizeSection = styled.div`
  margin-bottom: 1.5rem;
`;

const SizeOptions = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

const SizeOption = styled.div`
  padding: 0.625rem 1.25rem;
  border: 2px solid ${props => props.selected ? '#667eea' : '#e0e0e0'};
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 600;
  background: ${props => props.selected ? '#667eea' : 'white'};
  color: ${props => props.selected ? 'white' : '#1a1a1a'};
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #667eea;
  }
`;

const QuantitySection = styled.div`
  margin-bottom: 1.5rem;
`;

const QuantitySelector = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const QuantityButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  &:hover:not(:disabled) {
    background: #e0e0e0;
  }
  
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const QuantityInput = styled.input`
  width: 60px;
  text-align: center;
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  
  &:focus {
    outline: none;
    border-color: #667eea;
  }
  
  /* Hide spinner arrows */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const StockInfo = styled.div`
  font-size: 0.875rem;
  color: #28a745;
  font-weight: 600;
 
`;

const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`;

const BuyNowButton = styled.button`
  width: 90%;
  padding: 0.875rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const AddToCartButton = styled.button`
  width: 90%;
  padding: 0.875rem;
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    background: #f8f9fa;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const SecondaryButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
`;

const WishlistButton = styled.button`
  padding: 0.75rem;
  background: ${props => props.isWishlisted ? '#ff6b6b' : 'white'};
  color: ${props => props.isWishlisted ? 'white' : '#1a1a1a'};
  border: 1px solid ${props => props.isWishlisted ? '#ff6b6b' : '#e0e0e0'};
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => props.isWishlisted ? '#ff5252' : '#f8f9fa'};
  }
`;

const ShareButton = styled.button`
width: 90%;
  padding: 0.75rem;
  background: white;
  color: #1a1a1a;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    background: #f8f9fa;
  }
`;

const DeliveryInfo = styled.div`
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1.5rem;
`;

const DeliveryTitle = styled.div`
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const DeliveryText = styled.div`
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0.25rem;
`;

const SpecsSection = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e0e0e0;
`;

const SpecsTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 1rem 0;
`;

const SpecsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const SpecsRow = styled.tr`
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s ease;
  
  &:hover {
    background: #f8f9fa;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

const SpecsLabel = styled.th`
  padding: 0.875rem 1rem 0.875rem 0;
  text-align: left;
  font-weight: 600;
  color: #666;
  font-size: 0.875rem;
  width: 40%;
`;

const SpecsValue = styled.td`
  padding: 0.875rem 0;
  color: #1a1a1a;
  font-size: 0.875rem;
  font-weight: 500;
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  gap: 1rem;
`;

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #f0f0f0;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.div`
  font-size: 1rem;
  color: #666;
  font-weight: 500;
`;

const ErrorContainer = styled.div`
  text-align: center;
  padding: 3rem 2rem;
  background: white;
  border-radius: 12px;
  max-width: 600px;
  margin: 2rem auto;
`;

const ErrorTitle = styled.h3`
  font-size: 1.5rem;
  color: #ff4444;
  margin-bottom: 1rem;
`;

const ErrorText = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 2rem;
`;

const BackButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    background: #5568d3;
  }
`;

const ProductDetail = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [isWishlisted, setIsWishlisted] = useState(false);

  const { currentUser } = useContext(AuthContext) || {};
  const localStorageUser = JSON.parse(localStorage.getItem('userData'));
  const user = currentUser || localStorageUser;

  const getColorValue = (colorName) => {
    const colorMap = {
      'black': '#1a1a1a',
      'white': '#ffffff',
      'red': '#e74c3c',
      'blue': '#3498db',
      'green': '#27ae60',
      'yellow': '#f1c40f',
      'silver': '#bdc3c7',
      'gold': '#f39c12',
      'rose gold': '#e8b4b8',
      'navy': '#2c3e50',
      'brown': '#8b4513',
      'gray': '#7f8c8d',
      'grey': '#7f8c8d',
      'pink': '#e91e63',
      'purple': '#9b59b6',
      'orange': '#e67e22',
      'beige': '#f5f5dc',
      'teal': '#1abc9c',
      'burgundy': '#8e2a2a'
    };
    return colorMap[colorName?.toLowerCase()] || colorName;
  };

  useEffect(() => {
    const productRef = ref(db, `Watch/admin/products/${productId}`);
    const unsubscribe = onValue(productRef, (snapshot) => {
      const productData = snapshot.val();
      if (productData) {
        setProduct({
          id: productId,
          ...productData
        });
        
        if (productData.specifications?.colors?.length > 0) {
          setSelectedColor(productData.specifications.colors[0]);
        }
        
        if (productData.specifications?.sizes?.length > 0) {
          setSelectedSize(productData.specifications.sizes[0]);
        }
      } else {
        setError('Product not found');
      }
      setLoading(false);
    }, (error) => {
      setError('Error fetching product details');
      setLoading(false);
    });

    return () => unsubscribe();
  }, [productId]);

  const calculateCurrentPrice = () => {
    if (!product) return 0;
    const basePrice = parseFloat(product.price);
    const discountedPrice = product.discount > 0
      ? basePrice * (1 - product.discount / 100)
      : basePrice;
    return (discountedPrice * quantity).toFixed(2);
  };

  const calculateOriginalPrice = () => {
    if (!product) return 0;
    return (parseFloat(product.price) * quantity).toFixed(2);
  };

  const handleQuantityChange = (change) => {
    const newQuantity = quantity + change;
    if (newQuantity >= 1 && newQuantity <= 10) {
      setQuantity(newQuantity);
    }
  };

  const handleQuantityInput = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 1 && value <= 10) {
      setQuantity(value);
    }
  };

  const nextImage = () => {
    if (product.images && currentImageIndex < product.images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const prevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleAddToCart = async () => {
    if (!user || !user.id) {
      alert('Please login to add items to cart');
      navigate('/login', { state: { from: location.pathname } });
      return;
    }

    try {
      const cartRef = ref(db, `Watch/customers/${user.id}/cart`);
      const snapshot = await get(cartRef);
      const cartItems = snapshot.val() || {};

      const existingItemKey = Object.keys(cartItems).find(key =>
        cartItems[key].id === product.id &&
        cartItems[key].selectedColor === selectedColor &&
        cartItems[key].selectedSize === selectedSize
      );

      if (existingItemKey) {
        const itemRef = ref(db, `Watch/customers/${user.id}/cart/${existingItemKey}`);
        await runTransaction(itemRef, (currentData) => {
          if (currentData) {
            currentData.quantity += quantity;
          }
          return currentData;
        });
      } else {
        const newCartItem = {
          id: product.id,
          name: product.name,
          brand: product.brand,
          price: parseFloat(product.price),
          discount: product.discount || 0,
          image: product.images?.[0] || '',
          selectedColor,
          selectedSize,
          quantity,
          maxQuantity: 10,
          addedAt: Date.now()
        };

        await push(ref(db, `Watch/customers/${user.id}/cart`), newCartItem);
      }

      alert(`${quantity} ${product.name} added to cart`);
      navigate('/cart');

    } catch (err) {
      console.error('Error adding to cart:', err);
      alert('Failed to add item to cart. Please try again.');
    }
  };

  const handleBuyNow = () => {
    if (!user || !user.id) {
      alert('Please login to proceed with checkout');
      navigate('/login', { state: { from: location.pathname } });
      return;
    }

    const cartItem = {
      id: product.id,
      name: product.name,
      brand: product.brand,
      price: parseFloat(product.price),
      discount: product.discount || 0,
      image: product.images?.[0] || '',
      selectedColor,
      selectedSize,
      quantity,
      maxQuantity: 10,
      userId: user.id
    };

    localStorage.setItem('cart', JSON.stringify([cartItem]));
    navigate('/checkout', {
      state: {
        fromBuyNow: true,
        product: {
          ...cartItem,
          originalPrice: parseFloat(product.price)
        }
      }
    });
  };

  const toggleWishlist = () => {
    setIsWishlisted(!isWishlisted);
    if (!isWishlisted) {
      alert(`${product.name} added to wishlist`);
    } else {
      alert(`${product.name} removed from wishlist`);
    }
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: product.name,
        text: `Check out ${product.name} by ${product.brand}`,
        url: window.location.href,
      }).catch((error) => console.log('Error sharing', error));
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };

  const renderRating = (rating) => {
    const stars = [];
    const ratingValue = rating || 4.5;
    const fullStars = Math.floor(ratingValue);
    const hasHalfStar = ratingValue % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} style={{ color: '#ffc107', fontSize: '1rem' }} />);
    }

    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" style={{ color: '#ffc107', fontSize: '1rem' }} />);
    }

    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} style={{ color: '#ffc107', fontSize: '1rem' }} />);
    }

    return stars;
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <Container>
          <MainContent>
            <LoadingContainer>
              <LoadingSpinner />
              <LoadingText>Loading product details...</LoadingText>
            </LoadingContainer>
          </MainContent>
        </Container>
      </>
    );
  }

  if (error || !product) {
    return (
      <>
        <Navbar />
        <Container>
          <MainContent>
            <ErrorContainer>
              <ErrorTitle>{error || 'Product not found'}</ErrorTitle>
              <ErrorText>
                {error ? 'We encountered an error loading this product.' : 'This product might have been moved or deleted.'}
              </ErrorText>
              <BackButton onClick={() => navigate(-1)}>
                <FaChevronLeft /> Back to Products
              </BackButton>
            </ErrorContainer>
          </MainContent>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Container>
        <MainContent>
          <Breadcrumb>
            <a href="/">Home</a>
            <span>›</span>
            <a href="/products">Products</a>
            <span>›</span>
            <span>{product.name}</span>
          </Breadcrumb>

          <ProductContainer>
            <ProductContent>
              {/* Image Section */}
              <ImageSection>
                {product.images && product.images.length > 0 && (
                  <>
                    <ImageContainer>
                      <MainImage
                        src={product.images[currentImageIndex]}
                        alt={product.name}
                      />
                      {product.images.length > 1 && (
                        <>
                          <PrevButton
                            onClick={prevImage}
                            disabled={currentImageIndex === 0}
                          >
                            <BsArrowLeft />
                          </PrevButton>
                          <NextButton
                            onClick={nextImage}
                            disabled={currentImageIndex === product.images.length - 1}
                          >
                            <BsArrowRight />
                          </NextButton>
                        </>
                      )}
                    </ImageContainer>
                    
                    {product.images.length > 1 && (
                      <ThumbnailContainer>
                        {product.images.map((image, index) => (
                          <Thumbnail
                            key={index}
                            src={image}
                            alt={`${product.name} thumbnail ${index + 1}`}
                            active={index === currentImageIndex}
                            onClick={() => setCurrentImageIndex(index)}
                          />
                        ))}
                      </ThumbnailContainer>
                    )}
                  </>
                )}

                {/* Specifications Table */}
                {product.specifications && Object.keys(product.specifications).length > 0 && (
                  <SpecsSection>
                    <SpecsTitle>Product Specifications</SpecsTitle>
                    <SpecsTable>
                      <tbody>
                        {Object.entries(product.specifications).map(([key, value]) => {
                          if (key === 'colors' || key === 'sizes') return null;
                          return (
                            <SpecsRow key={key}>
                              <SpecsLabel>{key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}</SpecsLabel>
                              <SpecsValue>
                                {Array.isArray(value) ? value.join(', ') : value}
                              </SpecsValue>
                            </SpecsRow>
                          );
                        })}
                      </tbody>
                    </SpecsTable>
                  </SpecsSection>
                )}
              </ImageSection>

              {/* Details Section */}
              <DetailsSection>
                <ProductHeader>
                  <ProductTitle>{product.name}</ProductTitle>
                  <ProductBrand>{product.brand}</ProductBrand>
                  
                  <ProductRating>
                    <RatingBadge>
                      <FaStar style={{ fontSize: '0.875rem' }} />
                      4.4
                    </RatingBadge>
                    <ReviewCount>11 Reviews</ReviewCount>
                  </ProductRating>
                </ProductHeader>

                <PriceSection>
                  <PriceContainer>
                    <CurrentPrice>₹{calculateCurrentPrice()}</CurrentPrice>
                    {product.discount > 0 && (
                      <>
                        <OriginalPrice>₹{calculateOriginalPrice()}</OriginalPrice>
                        <DiscountBadge>{product.discount}% off</DiscountBadge>
                      </>
                    )}
                  </PriceContainer>
                  <TaxInfo>Inclusive of all taxes</TaxInfo>
                </PriceSection>

                <FeatureGrid>
                  <FeatureCard>
                    <FaShieldAlt />
                    <FeatureText>12 Months Warranty</FeatureText>
                  </FeatureCard>
                  <FeatureCard>
                    <FaTruck />
                    <FeatureText>Free Shipping Countrywide</FeatureText>
                  </FeatureCard>
                  <FeatureCard>
                    <FaUndo />
                    <FeatureText>Easy Return</FeatureText>
                  </FeatureCard>
                  <FeatureCard>
                    <FaCertificate />
                    <FeatureText>Serviced Across India</FeatureText>
                  </FeatureCard>
                </FeatureGrid>

                {product.description && (
                  <ProductDescription>
                    {product.description}
                  </ProductDescription>
                )}

                {/* Color Selection */}
                {product.specifications?.colors && product.specifications.colors.length > 0 && (
                  <ColorSection>
                    <SectionTitle>Strap Color : {selectedColor || 'Select'}</SectionTitle>
                    <ColorOptions>
                      {product.specifications.colors.map((color) => (
                        <ColorOption
                          key={color}
                          color={getColorValue(color)}
                          selected={selectedColor === color}
                          onClick={() => setSelectedColor(color)}
                          title={color}
                        />
                      ))}
                    </ColorOptions>
                  </ColorSection>
                )}

                {/* Size Selection */}
                {product.specifications?.sizes && product.specifications.sizes.length > 0 && (
                  <SizeSection>
                    <SectionTitle>Select Size</SectionTitle>
                    <SizeOptions>
                      {product.specifications.sizes.map((size) => (
                        <SizeOption
                          key={size}
                          selected={selectedSize === size}
                          onClick={() => setSelectedSize(size)}
                        >
                          {size}
                        </SizeOption>
                      ))}
                    </SizeOptions>
                  </SizeSection>
                )}

                {/* Quantity Section */}
                <QuantitySection>
                  <SectionTitle>Quantity</SectionTitle>
                  <QuantitySelector>
                    <QuantityButton
                      onClick={() => handleQuantityChange(-1)}
                      disabled={quantity <= 1}
                    >
                      −
                    </QuantityButton>
                    <QuantityInput
                      type="number"
                      value={quantity}
                      min="1"
                      max="10"
                      onChange={handleQuantityInput}
                    />
                    <QuantityButton
                      onClick={() => handleQuantityChange(1)}
                      disabled={quantity >= 10}
                    >
                      +
                    </QuantityButton>
                    <StockInfo>In Stock</StockInfo>
                  </QuantitySelector>
                </QuantitySection>

                {/* Action Buttons */}
                <ActionButtons>
                  <AddToCartButton onClick={handleAddToCart}>
                    <FaShoppingCart /> ADD TO CART
                  </AddToCartButton>
                  <BuyNowButton onClick={handleBuyNow}>
                    <HiOutlineSparkles /> BUY NOW
                  </BuyNowButton>
                  <ShareButton onClick={handleShare}>
                    <FaShare /> Share
                  </ShareButton>
                </ActionButtons>
              </DetailsSection>
            </ProductContent>
          </ProductContainer>
        </MainContent>
      </Container>
      <Footer />
    </>
  );
};

export default ProductDetail;
